import PartnerSearchWidget from './PartnerSearchWidget';

export default PartnerSearchWidget;
